export default __webpack_public_path__ + "static/media/arrow.a2b0e8b8.svg";